import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import environment from '@environments/environment';
import { FeatureFlagsResponse } from './types';

/**
 * Feature Flags HTTP Service
 *
 * Provides HTTP methods for fetching feature flags from the backend API.
 */
@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
  private readonly __http = inject(HttpClient);

  /**
   * Fetch all feature flags from backend
   * @returns Observable of feature flags response
   */
  getFeatureFlags(): Observable<FeatureFlagsResponse> {
    return this.__http.get<FeatureFlagsResponse>(
      `${environment.irisApi}/settings/feature-flags/`,
    );
  }

  /**
   * Update a feature flag (admin only)
   * @param flagKey - The feature flag key to update
   * @param enabled - Whether the flag should be enabled
   * @param reason - Reason for the change (required for audit trail)
   * @returns Observable of void
   */
  updateFeatureFlag(
    flagKey: string,
    enabled: boolean,
    reason: string,
  ): Observable<void> {
    return this.__http.put<void>(
      `${environment.irisApi}/admin/settings/feature-flags/`,
      { feature_key: flagKey, enabled, reason },
    );
  }
}
